import React from "react";
import styles from "./secondarybutton.module.css";
export const CustomSecondaryBtn = ({
	handleClick,
	buttonText,
}) => {
	return (
		<button
			onClick={handleClick}
			className={styles.secondaryBtn}
		>
			{buttonText}
		</button>
	);
};
